import MarkdownPreview from "@uiw/react-markdown-preview";
import * as React from "react";
import { PageLayout } from "src/components/PageLayout";

import docAttr from "../../../../apidoc/attr.md";
import * as styles from "./DocPage.module.less";

export const DocPage: React.FC = () => (
  <PageLayout title="Документация">
    <MarkdownPreview source={docAttr} className={styles.docPage} />
  </PageLayout>
);
